export default {
    toDays(d) {
        d = d || 0;
        return d / 24 / 60 / 60 / 1000;
    },

    daysInMonth(m, y) {
        const start_date = new Date(`${y}-${m}-01`);
        const end_date = new Date(start_date.getFullYear(), start_date.getMonth() + 1, 1);
        return Math.ceil(this.toDays(end_date - start_date));
    },

    dateFormat(dt, oper, localDate) {
        if (dt !== undefined) {
            let monthDay = null;
            let date_str = new Date(dt).toISOString();
            let dt_year = date_str.substring(0, 4)
            let dt_month = date_str.substring(5, 7)

            switch (oper) {
                case 'startMonth':
                    date_str = `${dt_year}-${dt_month}-01`;
                    break;

                case 'endMonth':
                    monthDay = this.daysInMonth(dt_month, dt_year);
                    date_str = `${dt_year}-${dt_month}-${monthDay}`;
                    break;

                default:
                    return undefined;
            }

            if (localDate !== null) {
                if (localDate === 'sys') {
                    return new Date(date_str).toISOString().substring(0, 10);
                } else {
                    return new Date(date_str).toISOString().substring(0, 10).replaceAll('/', '-');
                }
            } else {
                return date_str;
            }
        } else {
            return undefined;
        }
    }
}